import { effects } from 'redux-saga'

import { loadClients } from 'internal-components/src/redux/modules/client'
import { loadUserSignups } from '../modules/signupEdit/actions'

export default function* loadAuthenticatedData() {
  const state = yield effects.select()
  const user = state.authentication.get('user')

  if (!user) {
    return
  }

  const clientIds = user
    .get('relationships')
    .map(r => r.get('client_id'))
    .toArray()

  yield [
    effects.put.resolve(loadUserSignups()),
    effects.put.resolve(loadClients(clientIds)),
  ]
}



// WEBPACK FOOTER //
// ./src/redux/sagas/loadAuthenticatedData.js